import notifikasiApi from '../../services/notifikasiApi'

const SET_NOTIFIKASI = "SET_NOTIFIKASI"

const state = {
	notifikasi: null,
}

const mutations = {
	[SET_NOTIFIKASI](state, data) {
		state.notifikasi = data
	}
}

const actions = {
	async fetchNotifikasi({ commit, getters }) {
		let token = getters.getAuthService.token
		return await notifikasiApi.fetchNotifikasi(token)
	},
	setNotifikasi({ commit }, data) {
		commit(SET_NOTIFIKASI, data)
	},
	async sendNotifikasi({ getters }, data) {
		let token = getters.getAuthService.token
		return await notifikasiApi.sendNotifikasi(token, data)
	},
	async sendNotifikasiNoAuth({ getters }, data) {
		return await notifikasiApi.sendNotifikasiNoAuth(data)
	},
	async clearNotifikasi({ getters }, data) {
		let token = getters.getAuthService.token
		return await notifikasiApi.clearNotifikasi(token, data)
	},
}

const getters = {
	getNotifikasi: state => {
		return state.notifikasi
	},
}

export default {
	state,
	mutations,
	actions,
	getters
}